import { QueryClient, QueryCache } from '@tanstack/react-query'
import { useConnectionStore } from '../stores/connection'

// Treat timeouts / dropped network / server 5xx as a "connection degraded" signal.
// 4xx (auth, not-found) are real app responses, not connectivity problems.
function isConnectivityError(error: unknown): boolean {
  const e = error as { code?: string; response?: { status?: number }; message?: string }
  if (e?.code === 'ECONNABORTED' || e?.code === 'ERR_NETWORK') return true // axios timeout / network
  const status = e?.response?.status
  if (status == null) return true // no response reached us at all
  return status >= 500
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (isConnectivityError(error)) useConnectionStore.getState().setDegraded(true)
    },
    onSuccess: () => {
      // Any successful fetch means the connection is back.
      useConnectionStore.getState().setDegraded(false)
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error: unknown) => {
        const status = (error as { response?: { status?: number } })?.response?.status
        if (status === 401 || status === 403 || status === 404) return false
        return failureCount < 2
      },
    },
  },
})
